Postlogin = (function (self) {
    self.VideosWatched = {};
    const me = self.VideosWatched;

    me.progress_bars = [];

    me.setupProgressBars = function () {
        if ($('.progress-indicator').length) {
            $('.progress-indicator').each(function () {
                const progress = $(this).attr('data-progress');
                const userId = $(this).attr('data-user-id');
                const bar = new ProgressBar.Line(`#${$(this).attr('id')}`, {
                    strokeWidth: 3,
                    easing: 'easeInOut',
                    duration: 1400,
                    color: '#000',
                    trailColor: '#eee',
                    trailWidth: 3,
                    svgStyle: { width: '100%', height: '100%' },
                    from: { color: '#CDCD00' },
                    to: { color: '#1A9D5A' },
                    step(state, progressBar) {
                        progressBar.path.setAttribute('stroke', state.color);
                        progressBar.setText(`${Math.round(progressBar.value() * 100)} %`);
                    },
                });
                bar.animate(progress / 100); // Value from 0.0 to 1.0
                me.progress_bars[userId] = bar;
            });
        }
    };

    me.$table = $('#videos-watched-table');

    me.initTable = function () {
        const userId = me.$table.attr('data-user-id');
        const currentUserId = me.$table.attr('data-current-user-id');
        const userFirstName = me.$table.attr('data-user-first-name');

        me.$table.bootstrapTable({
            formatNoMatches() {
                if (userId === currentUserId) {
                    return 'You have not yet watched any videos!';
                }

                return `${userFirstName} has not yet watched any videos.`;
            },
            method: 'post',
            contentType: 'application/x-www-form-urlencoded',
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'user_id',
            minimumCountColumns: '2',
            pagination: true,
            searchAlign: 'left',
            search: true,
            sortName: 'date_watched',
            sortOrder: 'desc',
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: userId === currentUserId ? '/my-profile/videos-watched/json/' : `/users/${userId}/videos-watched/json/`,
            pageSize: 25,
            queryParamsType: 'other',
            queryParams(params) {
                const myParams = {};
                myParams.search_term = params.searchText;
                myParams.page = params.pageNumber;
                myParams.page_size = params.pageSize;
                myParams.order_by = params.sortName;
                myParams.sort_order = params.sortOrder;

                return myParams;
            },
            columns: [
                {
                    title: 'Date Watched',
                    field: 'date_watched',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Type',
                    field: 'video_type',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Video Name',
                    field: 'display_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: '% Watched',
                    field: 'percent_watched',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            responseHandler(res) {
                me.$table.closest('.light-blur').removeClass('light-blur');
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                formattedResult.rows.map((result) => {
                    let row = result;
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    row = Jr.Utils.convertRowDate(row, 'l LT', []);
                    row.percent = row.percent_watched;
                    row.percent_watched = ''
                        + '<div'
                        + '    class="progress-indicator hidden-print"'
                        + `    id="student-progress-${row.view_id}"`
                        + `    data-progress="${row.percent_watched}"`
                        + `    data-user-id="${row.user_id}"`
                        + '    ></div>'
                        + `<span class="visible-print">${row.percent_watched}%</span>`;
                    return row;
                });
                return formattedResult;
            },
            onLoadSuccess() {
                me.setupProgressBars();
            },
            rowStyle(row) {
                let classes = '';

                if (row.percent < 33.3333) {
                    classes += 'danger ';
                } else if (row.percent < 66.6666) {
                    classes += 'warning ';
                } else if (row.percent < 100) {
                    classes += 'info ';
                } else {
                    classes += 'success ';
                }

                return {
                    classes,
                };
            },
        });
    };

    me.init = function () {
        me.initTable();
    };

    return self;
}(Postlogin || {}));
